import axios from "axios";
import { Markup } from "interweave";
import React, { useContext, useEffect, useState } from "react";
import { serverInfo } from "../../../../../../App";
import StarShowcaseModal from "../../../../../Modal/StarShowcaseModal/StarShowcaseModal";
import "./Activitse.css";

const Souvenir = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [activities, setActivities] = useState([]);
  const [loading, serLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [detailsSouvenir, setDetailsSouvenir] = useState({});

  useEffect(() => {
    axios.get(`api/user/souvenir/activities/list`).then((res) => {
      if (res.status === 200) {
        setActivities(res.data?.userSouvenir);
      }
    });
  }, []);

  const handleActivity = (data) => {
    setShow(true);
    serLoading(false);
    axios.get(`api/user/souvenir/activities/view/${data}`).then((res) => {
      if (res.status === 200) {
        setDetailsSouvenir(res.data?.detailsSouvenir);
        serLoading(true);
      }
    });
  };
  return (
    <>
      <div className="row mt-3">
        {/* {activities.} */}
        {activities?.map((activity, i) => (
          <div class="col-md-6 col-lg-4 mb-3" key={i}>
            <div className="card text-center CardEn ">
              <img
                src={imageCdnUrl + activity?.image}
                alt="Img1"
                className="ImgAc"
                height="180px"
              />

              {/* <Link to="/learning-activities"> */}
              <h6 className="fw-bold pt-3 pb-1 EnHead">
                {/* {activity.souvenir?.title} */}
                <Markup
                  content={activity.souvenir?.title.substring(0, 40)}
                  title={activity.souvenir?.title}
                ></Markup>
              </h6>

              <button
                className="btn-x-r-ac"
                style={{ fontSize: "30px" }}
                onClick={() => handleActivity(activity?.id)}
              >
                <i className="fas fa-arrow-alt-circle-right"></i>
              </button>
              {/* </Link> */}
            </div>
          </div>
        ))}

        <StarShowcaseModal
          souvenir={detailsSouvenir}
          loading={loading}
          show={show}
          onHide={() => setShow(false)}
        />

        {/* <PurchaseModal show={modalShow} onHide={()=> setModalShow(false)}  activity={singleActivityData} /> */}
      </div>
    </>
  );
};

export default Souvenir;
